import { FC, ReactNode } from 'react';
import { Paper } from '@mui/material';
import CalloutDescription from './CalloutDescription';
import CalloutHeader from './CalloutHeader';
import CalloutTitle from './CalloutTitle';
import Column from '../Column';
import ReactUtils from '../../utils/ReactUtils';

interface CalloutProps {
    children?: ReactNode;
    title?: ReactNode;
    description?: ReactNode;
}

const Callout: FC<CalloutProps> = ({ children, title = '', description = '' }) => {
    const shouldRenderTitle: boolean = ReactUtils.isReactNodeEmpty(title) === false;
    const shouldRenderDescription: boolean = ReactUtils.isReactNodeEmpty(description) === false;
    const shouldRenderHeader: boolean = shouldRenderTitle || shouldRenderDescription;

    return (
        <Paper variant="outlined" sx={{ width: 660, px: 3, py: 5 }}>
            <Column gap={3}>
                {shouldRenderHeader && (
                    <CalloutHeader>
                        {title && <CalloutTitle>{title}</CalloutTitle>}

                        {description && <CalloutDescription>{description}</CalloutDescription>}
                    </CalloutHeader>
                )}

                {children}
            </Column>
        </Paper>
    );
};

export type { CalloutProps };
export default Callout;
